export default {
    HEADER: 'Lokal',
    PLACEHOLDER_NAME: 'Unesite naziv lokala',
    LABEL_NAME: 'Naziv lokala',
    PLACEHOLDER_PHONE_NUMBER: 'Unesite broj telefona',
    LABEL_PHONE_NUMBER: 'Broj telefona',
    PLACEHOLDER_MIN_ORDER_AMOUNT: 'Minimalan iznos porudžbine',
    LABEL_MIN_ORDER_AMOUNT: 'Minimalan iznos',
    LABEL_COMPANY: 'Kompanija',
    LABEL_TERMINAL: 'Terminal',
    LABEL_WEBSITE: 'Web sajt',
    PLACEHOLDER_COUNTRY: 'Unesite državu',
    LABEL_COUNTRY: 'Država',
    PLACEHOLDER_STREET: 'Unesite ulicu',
    LABEL_STREET: 'Ulica',
    PLACEHOLDER_STREET_NUMBER: 'Unesite broj',
    LABEL_STREET_NUMBER: 'Broj',
    PLACEHOLDER_CITY: 'Unesite grad',
    LABEL_CITY: 'Grad',
    PLACEHOLDER_ZIP_CODE: 'Unesite poštanski broj',
    LABEL_ZIP_CODE: 'Poštanski broj',
    PLACEHOLDER_FLOOR: 'Unesite sprat',
    LABEL_FLOOR: 'Sprat',
    PLACEHOLDER_APARTMENT: 'Unesite apartman',
    LABEL_APARTMENT: 'Apartman',
    PLACEHOLDER_DESCRIPTION: 'Unesite opis',
    LABEL_DESCRIPTION: 'Opis',
    PLACEHOLDER_LONGITUDE: 'Unesite geografsku dužinu',
    LABEL_LONGITUDE: 'Geografska dužina',
    PLACEHOLDER_LATITUDE: 'Unesite geografsku širinu',
    LABEL_LATITUDE: 'Geografska širina',
    LABEL_DELIVERY_ZONES_PRICES: 'Cene dostave po zonama',
    LABEL_DELIVERY_ZONES_PRICE: 'Cena',
    CANCEL: 'Poništi',
    SUBMIT: 'Sačuvaj',
    LABEL_WORKING_HOURS: 'Radno vreme',
    LABEL_CLOSED: 'Zatvoreno',
    LABEL_OPENING_TIME: 'Vreme otvaranja',
    LABEL_CLOSING_TIME: 'Vreme zatvaranja',
    LABEL_DAY_MONDAY: 'Ponedeljak',
    LABEL_DAY_TUESDAY: 'Utorak',
    LABEL_DAY_WEDNESDAY: 'Sreda',
    LABEL_DAY_THURSDAY: 'Četvrtak',
    LABEL_DAY_FRIDAY: 'Petak',
    LABEL_DAY_SATURDAY: 'Subota',
    LABEL_DAY_SUNDAY: 'Nedelja',
};
